import React from 'react';
import {Stack} from '@mui/material';
import {Body, Headline, Icon} from '@lightricks/react-design-system';
import {sanitizeBriefHtml} from '../brief/BriefHtml';
import type {PrepStatusPresentation} from './prepStatus';
import styles from './PrepPage.module.scss';

interface PrepStatusCardProps {
  presentation: PrepStatusPresentation;
  children?: React.ReactNode;
  details?: React.ReactNode;
}

function PrepStatusCard({
  presentation,
  children,
  details,
}: PrepStatusCardProps) {
  const {title, descriptionHtml, iconName, iconAppearance} = presentation;

  return (
    <Stack
      component="section"
      alignItems="center"
      spacing={5}
      className={styles.stack}
      data-testid="prep-status"
    >
      <Stack alignItems="center" spacing={2}>
        <Icon size="large" appearance={iconAppearance} name={iconName} />
        <Headline size="md" component="h1" data-testid="prep-status-title">
          {title}
        </Headline>
        {children ? (
          <Body size="md" component="div" className={styles.statusBody}>
            {children}
          </Body>
        ) : (
          descriptionHtml && (
            <Body
              size="md"
              component="div"
              className={styles.statusBody}
              data-testid="prep-status-description"
              dangerouslyInnerHTML={sanitizeBriefHtml(descriptionHtml)}
            />
          )
        )}
      </Stack>
      {details}
    </Stack>
  );
}

export default PrepStatusCard;
